export const SEARCH_VENUES_WITH_PRODUCTS= 'SEARCH_VENUES_WITH_PRODUCTS'
export const SEARCH_VENUES_WITH_PRODUCTS_SUCCESS= 'SEARCH_VENUES_WITH_PRODUCTS_SUCCESS'
export const SEARCH_VENUES_WITH_PRODUCTS_ERROR='SEARCH_VENUES_WITH_PRODUCTS_ERROR'

export const SearchVenuesWithProducts= (data) => ({
    type: SEARCH_VENUES_WITH_PRODUCTS,
    payload: data
})


